import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-patient-prescriptions',
  templateUrl: './patient-prescriptions.component.html',
  styleUrls: ['../patient-profile/patient-profile.component.scss', './patient-prescriptions.component.scss']
})
export class PatientPrescriptionsComponent implements OnInit {

  id:any = 0;

  data:any = {list:[]}
  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.loadData();
  }

  loadData(){
    this.dataService.getClientMedicines(this.id).subscribe( (data: any[] )=> {
      this.data = data;
    });
  }

}
